<template>
<!--     pb-1 border-bottom m-2-->
        <div class="d-flex flex-column">
            <div class="form-field-label text-secondary" :class="{ 'text-nowrap': labelNowrap }">
                {{ label }}
            </div>
            <div>
                <div v-if="!editable" class="mt-2">
                    <slot name="value">
                        <span v-if="value !== undefined && value !== null && value !== ''">
                            <span v-if="Array.isArray(value)" class="d-flex w-100 flex-wrap">
                                <span class="tag" v-for="(v, i) in value">
                                    {{ v }}
                                </span>
                            </span>
                            <span v-else>{{ value }}</span>
                        </span>
                        <span v-else class="text-secondary">&mdash;</span>
                    </slot>
                </div>
                <div v-else>
                    <slot name="field">
                    </slot>
                    <div v-if="feedback" class="text-danger">
                        <small>{{ feedback }}</small>
                    </div>
                </div>
            </div>
            <div>
                <slot name="help">
                </slot>
            </div>
        </div>
</template>

<script>
    export default {
        name: "FormField",
        props: {
            label: { type: String, default: null },
            labelNowrap: { type: Boolean, default: false },
            editable: { type: Boolean, default: false },
            value: { type: null, default: null },
            feedback: { type: String }
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .required {
        & .form-field-label::after {
            color: $danger;
            content: '  *';
        }
    }

    .tag {
        background-color: lighten($primary, 42%);
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px
    }

    .value-bg-info {
        & .tag {
            background-color: lighten($info, 45%);
        }
    }
</style>